import api from './api';

export interface Usuario {
    id?: string;
    usuario: string;
    username?: string;
    nombre?: string;
    password?: string;
    email: string;
    role: string;
    createdAt?: string;
    lastLogin?: string;
}

export interface UsuarioSearchParams {
    searchTerm?: string;
    pageNumber: number;
    pageSize: number;
}

export interface UsuarioPagedResult {
    items: Usuario[];
    totalCount: number;
    pageNumber: number;
    pageSize: number;
    totalPages: number;
}

const usuarioService = {
    getUsuarios: async (params?: UsuarioSearchParams): Promise<Usuario[]> => {
        const response = await api.get('/api/Users', params ? { params } : {});
        const data = response.data;
        
        if (Array.isArray(data)) {
            return data;
        }
        
        if (data && typeof data === 'object' && 'items' in data) {
            return data.items as Usuario[];
        }
        
        return [];
    },

    getUsuario: async (username: string): Promise<Usuario> => {
        const response = await api.get<Usuario>(`/api/Users/${encodeURIComponent(username)}`);
        return response.data;
    },

    createUsuario: async (usuario: Usuario): Promise<Usuario> => {
        const response = await api.post<Usuario>('/api/Users', usuario);
        return response.data;
    },

    updateUsuario: async (username: string, usuario: Usuario): Promise<void> => {
        await api.put(`/api/Users/${encodeURIComponent(username)}`, usuario);
    },

    deleteUsuario: async (username: string): Promise<void> => {
        await api.delete(`/api/Users/${encodeURIComponent(username)}`);
    }
};

export default usuarioService;
